import React, { useState, useEffect } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { RoundedDialog, StandardDialogActions } from '../../Global/Components';
import axios from 'axios';

export default function YouTubeModal({ open, onClose, videoUrl, post, canClose = true }) {
  const [player, setPlayer] = useState(null);
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const videoId = extractVideoIdFromUrl(videoUrl);

  //Extracting video
  function extractVideoIdFromUrl(url) {
    const match = url.match(
      /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  }

  // Custom player for homepage
  useEffect(() => {
    if (canClose === false && open && videoId && !window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        initializePlayer();
      };
    } else if (canClose === false && open && videoId && window.YT) {
      initializePlayer();
    }

    if (open && canClose === false) {
      setIsVideoEnded(false);
    }
    if (open) {
      axios.post('/help/setWatchedVideo', { id: post._id }).then((data) => console.log(data));
    }

    return () => {
      if (player) {
        player.destroy();
      }
    };
  }, [open, videoId, canClose]); //eslint-disable-line

  const initializePlayer = () => {
    const newPlayer = new window.YT.Player('youtube-player', {
      height: '100%',
      width: '100%',
      videoId: videoId,
      playerVars: {
        autoplay: 1,
        controls: 1,
      },
      events: {
        onReady: (event) => {
          setPlayer(event.target);
        },
        onStateChange: (event) => {
          if (event.data === window.YT.PlayerState.ENDED) {
            setIsVideoEnded(true);
          }
        },
      },
    });
  };

  const handleClose = () => {
    if (canClose || isVideoEnded) {
      onClose();
    }
  };

  return (
    <RoundedDialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      className="scroll-bar"
      disableEscapeKeyDown={canClose === false && !isVideoEnded}
      disableBackdropClick={canClose === false && !isVideoEnded}
    >
      <DialogTitle>Watch Q-Video</DialogTitle>
      <DialogContent
        sx={{
          padding: 0,
          height: '80vh',
          width: '60vw',
          maxWidth: '100%',
          overflowX: 'hidden',
        }}
      >
        {videoId ? (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {canClose === false ? (
              <div
                id="youtube-player"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
            ) : (
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </Box>
        ) : (
          <div>Invalid YouTube URL</div>
        )}
      </DialogContent>
      <StandardDialogActions onClose={canClose || isVideoEnded ? handleClose : null} />
    </RoundedDialog>
  );
}
